import { render, staticRenderFns } from "./WXUserCenter.vue?vue&type=template&id=5cdf8212&scoped=true"
import script from "./WXUserCenter.vue?vue&type=script&lang=js"
export * from "./WXUserCenter.vue?vue&type=script&lang=js"
import style0 from "./WXUserCenter.vue?vue&type=style&index=0&id=5cdf8212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf8212",
  null
  
)

export default component.exports